import { render, staticRenderFns } from "./spaceNotList.vue?vue&type=template&id=32720e9b&scoped=true"
import script from "./spaceNotList.vue?vue&type=script&lang=js"
export * from "./spaceNotList.vue?vue&type=script&lang=js"
import style0 from "./spaceNotList.vue?vue&type=style&index=0&id=32720e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32720e9b",
  null
  
)

export default component.exports